import { NodeKinds } from "interfaces/enums";

export const initialNodesStructure = {
  id: "parent-node-id",
  folderName: "INITIAL_NODES_STRUCTURE_BUILDING",
  parentId: null,
  kind: NodeKinds.FOLDER,
  position: 0,
  folderDescription: null,
  nodes: [
    {
      id: "child-1-node",
      folderName: "INITIAL_NODES_STRUCTURE_FLOOR",
      parentId: "parent-node-id",
      kind: NodeKinds.FOLDER,
      position: 0,
      folderDescription: null,
      nodes: [
        {
          id: "child-2-node",
          folderName: "INITIAL_NODES_STRUCTURE_ROOM",
          parentId: "child-1-node",
          kind: NodeKinds.FOLDER,
          position: 0,
          folderDescription: null,
          nodes: [],
        },
      ],
    },
  ],
};
